<form>
  <mat-dialog-content class="!grid">
    <p class="dialog-title pt-0">Terminar Seguimiento</p>
    <hr class="dialog-divider" />
    <p class="dialog-subtitle">SELECCIONA SEGUIMIENTOS A TERMINAR</p>

    <div class="">
      @for (entrada of entradas; track $index) {
      <div class="flex justify-between  items-center">
        <div class="grow">
          <p class="!truncate !text-balance !m-0 list-item-black">
            {{ entrada.nombreEntrada }}
          </p>
          <p class="!truncate !text-balance !m-0 list-item">
            {{ entrada.justificacionSeguimiento }}
          </p>
          <hr class="!mb-2" />
        </div>
        <mat-checkbox
          [color]="'primary'"
          [(ngModel)]="entrada.selected"
          (change)="updateSelectAllState()"
          name="entrada_{{ $index }}"
          class="example-margin"></mat-checkbox>
      </div>
      }
      <div class="flex justify-between items-center !mt-2">
        <p class="select-all">Seleccionar todos</p>
        <mat-checkbox
          [color]="'warn'"
          name="selectAllChecked"
          [(ngModel)]="selectAllChecked"
          (change)="selectAll($event.checked)"
          class="example-margin"></mat-checkbox>
      </div>
      <hr class="hr-black" />
    </div>
    <mat-form-field class="!grow">
      <mat-label>Justificación</mat-label>

      <textarea
        cdkTextareaAutosize
        type="text"
        placeholder="Justificación"
        aria-label="text"
        [formControl]="motivoJustificacion"
        name="motivoJustificacion"
        maxlength="40000"
        matInput
        matAutosizeMinRows="1"
        matAutosizeMaxRows="10">
      </textarea>

      <!-- <input
        type="text"
        placeholder="Justificación"
        aria-label="text"
        [formControl]="motivoJustificacion"
        name="motivoJustificacion"
        maxlength="40000"
        matInput /> -->
      <mat-hint align="end">
        {{ motivoJustificacion.value?.length || 0 }} / 40000
      </mat-hint>
      @if(motivoJustificacion.hasError('required')&&motivoJustificacion.touched)
      {
      <mat-error>Campo obligatorio</mat-error>
      }
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions class="!justify-end">
    <button
      class="uppercase-button"
      mat-raised-button
      [mat-dialog-close]="false">
      CANCELAR
    </button>
    <button
      mat-flat-button
      [color]="'primary'"
      [disabled]="
        motivoJustificacion.invalid || getEntradasChecked().length <= 0
      "
      (click)="save()">
      ACEPTAR
    </button>
  </mat-dialog-actions>
</form>
